<template>
  <div class="resume-view-page">
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content" v-loading="loading">
        <div class="resume-shell">
          <div class="resume-header">
            <div>
              <div class="resume-title">简历详情</div>
              <div class="resume-subtitle">查看基础资料、求职意向与经历信息</div>
            </div>
          </div>

          <div class="resume-card">
            <div class="section-block">
              <div class="section-title">基本信息</div>
              <div class="basic-section">
                <div class="basic-info-grid">
                  <div class="info-pair">
                    <span class="info-label">姓名：</span>
                    <span class="info-value">{{ getValue(basicInfo.name) }}</span>
                  </div>
                  <div class="info-pair">
                    <span class="info-label">身份：</span>
                    <span class="info-value">{{ getValue(otherInfo.professional_identity) }}</span>
                  </div>
                  <div class="info-pair">
                    <span class="info-label">年龄：</span>
                    <span class="info-value">{{ getValue(basicInfo.age) }}</span>
                  </div>
                  <div class="info-pair">
                    <span class="info-label">联系电话：</span>
                    <span class="info-value">{{ getValue(basicInfo.phone) }}</span>
                  </div>
                  <div class="info-pair">
                    <span class="info-label">邮箱：</span>
                    <span class="info-value">{{ getValue(basicInfo.contact_email) }}</span>
                  </div>
                  <div class="info-pair">
                    <span class="info-label">常驻城市：</span>
                    <span class="info-value">{{ getValue(basicInfo.resident_city) }}</span>
                  </div>
                </div>
                <div class="avatar-wrap">
                  <el-image
                    v-if="basicInfo.avatar"
                    :src="basicInfo.avatar"
                    fit="cover"
                    class="avatar-image"
                  >
                    <div slot="error" class="avatar-placeholder">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div v-else class="avatar-placeholder">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="section-block">
              <div class="section-title">求职意向</div>
              <div class="info-grid two-column">
                <div class="info-pair">
                  <span class="info-label">工作形式：</span>
                  <span class="info-value">{{ getValue(jobIntention.work_type_text) }}</span>
                </div>
                <div class="info-pair">
                  <span class="info-label">期望职位：</span>
                  <span class="info-value">{{ getValue(jobIntention.expected_position) }}</span>
                </div>
                <div class="info-pair">
                  <span class="info-label">期望薪资：</span>
                  <span class="info-value">{{ getValue(jobIntention.expected_salary) }}</span>
                </div>
                <div class="info-pair">
                  <span class="info-label">工作城市：</span>
                  <span class="info-value">{{ getValue(jobIntention.working_city) }}</span>
                </div>
              </div>
            </div>

            <div class="section-block">
              <div class="section-title">教育经历</div>
              <div class="info-grid two-column">
                <div class="info-pair">
                  <span class="info-label">学校名称：</span>
                  <span class="info-value">{{ getValue(education.school_name) }}</span>
                </div>
                <div class="info-pair">
                  <span class="info-label">学历：</span>
                  <span class="info-value">{{ getValue(education.education) }}</span>
                </div>
                <div class="info-pair">
                  <span class="info-label">所学专业：</span>
                  <span class="info-value">{{ getValue(education.major) }}</span>
                </div>
                <div class="info-pair">
                  <span class="info-label">在校时间：</span>
                  <span class="info-value">{{ getValue(education.enrollment_period) }}</span>
                </div>
              </div>
            </div>

            <div class="section-block">
              <div class="section-title">工作经历</div>
              <div class="info-grid two-column">
                <div class="info-pair">
                  <span class="info-label">公司名称：</span>
                  <span class="info-value">{{ getValue(primaryWorkExperience.company_name) }}</span>
                </div>
                <div class="info-pair">
                  <span class="info-label">在职时间：</span>
                  <span class="info-value">{{ getValue(primaryWorkExperience.employment_period) }}</span>
                </div>
                <div class="info-pair">
                  <span class="info-label">岗位类型：</span>
                  <span class="info-value">{{ getValue(primaryWorkExperience.position_type) }}</span>
                </div>
              </div>
              <div class="block-field">
                <div class="block-label">工作内容：</div>
                <el-input
                  type="textarea"
                  :rows="5"
                  resize="none"
                  :value="getValue(primaryWorkExperience.work_content)"
                  disabled
                  class="content-textarea"
                >
                </el-input>
              </div>
            </div>

            <div class="section-block">
              <div class="section-title">其他信息</div>
              <div class="other-section">
                <div class="radio-row">
                  <span class="radio-label">健康证</span>
                  <el-radio-group :value="healthCertificateValue" disabled>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </div>
                <div class="radio-row">
                  <span class="radio-label">驾驶证</span>
                  <el-radio-group :value="driverLicenseValue" disabled>
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>

            <div class="section-block section-block-last">
              <div class="section-title">个人优势</div>
              <div class="block-field block-field-full">
                <el-input
                  type="textarea"
                  :rows="5"
                  resize="none"
                  :value="getValue(otherInfo.personal_advantages)"
                  disabled
                  class="content-textarea"
                >
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";

function createDefaultResumeData() {
  return {
    basic_info: {},
    job_intention: {},
    education: {},
    work_experience: [],
    other_info: {},
    attachment: {},
    raw: {},
  };
}

export default {
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      loading: false,
      resumeData: createDefaultResumeData(),
    };
  },
  computed: {
    basicInfo() {
      return this.resumeData.basic_info || {};
    },
    jobIntention() {
      return this.resumeData.job_intention || {};
    },
    education() {
      return this.resumeData.education || {};
    },
    otherInfo() {
      return this.resumeData.other_info || {};
    },
    healthCertificateValue() {
      return this.normalizeRadioValue(this.otherInfo.health_certificate);
    },
    driverLicenseValue() {
      return this.normalizeRadioValue(this.otherInfo.driver_license);
    },
    primaryWorkExperience() {
      const list = Array.isArray(this.resumeData.work_experience)
        ? this.resumeData.work_experience
        : [];
      return list[0] || {};
    },
  },
  methods: {
    getValue(value) {
      return value === undefined || value === null || value === "" ? "-" : value;
    },
    normalizeRadioValue(value) {
      if (value === 1 || value === "1" || value === true) {
        return 1;
      }
      if (value === 0 || value === "0" || value === false) {
        return 0;
      }
      return "";
    },
    async init() {
      const mobile = this.$route.query.mobile || "";
      const id_number = this.$route.query.id_number || "";
      if (!mobile && !id_number) {
        this.$message.warning("缺少手机号或身份证号");
        this.$router.push({ path: "/candidate/resumeLibrary" });
        return;
      }

      this.loading = true;
      try {
        const data = await this.$api.resumeView({
          mobile,
          id_number,
        });
        this.resumeData = {
          ...createDefaultResumeData(),
          ...(data || {}),
        };
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.resume-view-page {
  min-height: 100%;
  background: #f5f7fb;

  :deep(.main-page-content) {
    padding: 24px;
  }

  :deep(.el-textarea.is-disabled .el-textarea__inner) {
    min-height: 120px;
    padding: 14px 16px;
    border-color: #dfe6f0;
    background: #fbfcfe;
    color: #606266;
    line-height: 1.8;
  }

  :deep(.el-radio__input.is-disabled + span.el-radio__label) {
    color: #606266;
  }

  :deep(.el-radio__input.is-disabled.is-checked .el-radio__inner) {
    border-color: #409eff;
    background: #409eff;
  }
}

.resume-shell {
  max-width: 1040px;
}

.resume-header {
  margin-bottom: 16px;
}

.resume-title {
  font-size: 26px;
  font-weight: 700;
  color: #1f2d3d;
}

.resume-subtitle {
  margin-top: 6px;
  font-size: 14px;
  color: #8c98a8;
}

.resume-card {
  width: 100%;
  padding: 8px 28px 12px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.06);
}

.section-block {
  padding: 14px 0 16px;
  border-bottom: 1px solid #eef2f7;
}

.section-block-last {
  border-bottom: none;
  padding-bottom: 4px;
}

.section-title {
  position: relative;
  margin: 0 0 10px;
  padding-left: 12px;
  font-size: 22px;
  font-weight: 700;
  color: #303133;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 4px;
    width: 4px;
    height: 22px;
    border-radius: 2px;
    background: #409eff;
  }
}

.basic-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.basic-info-grid,
.info-grid {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 48px;
  row-gap: 8px;
}

.two-column {
  margin-bottom: 2px;
}

.info-pair {
  display: flex;
  align-items: flex-start;
  min-height: 30px;
  font-size: 16px;
  line-height: 1.6;
  color: #303133;
}

.info-label {
  width: 96px;
  flex-shrink: 0;
  font-weight: 700;
  color: #303133;
}

.info-value {
  flex: 1;
  color: #606266;
  word-break: break-word;
}

.avatar-wrap {
  width: 120px;
  flex-shrink: 0;
  padding-top: 2px;
}

.avatar-image,
.avatar-placeholder {
  width: 120px;
  height: 120px;
  border: 1px solid #dfe6f0;
  border-radius: 12px;
  overflow: hidden;
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f7faff 0%, #eef4fb 100%);
  color: #c0c4cc;
  font-size: 56px;
}

.block-field {
  margin-top: 6px;
  max-width: 760px;
}

.block-field-full {
  max-width: 840px;
}

.block-label {
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}

.other-section {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 44px;
}

.radio-row {
  display: flex;
  align-items: center;
  min-height: 30px;
  font-size: 16px;
}

.radio-label {
  width: 80px;
  font-weight: 700;
  color: #303133;
}

@media screen and (max-width: 900px) {
  .resume-view-page {
    :deep(.main-page-content) {
      padding: 16px;
    }
  }

  .resume-card {
    padding: 4px 18px 8px;
  }

  .basic-section {
    flex-direction: column-reverse;
  }

  .basic-info-grid,
  .info-grid {
    grid-template-columns: 1fr;
  }

  .avatar-wrap {
    width: 100%;
    padding-top: 0;
  }

  .avatar-image,
  .avatar-placeholder {
    width: 120px;
    height: 120px;
  }

  .other-section {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
